import Notifications from 'react-notification-system-redux';
import { connect } from 'react-redux';

import { getStatusByName } from '../../../../constants/assignments';
import addAbilityToOpenModal from '../../../../utilities/modalHOC';
import {
  getGeneralRolesPermissions,
  getRolesPermissions,
  getUser,
} from '../../../Login/selectors';
import {
  onShowQuestionDetails,
  onShowQuestionOverview,
  setLoading,
  setLoadingCreateGPTquestion,
  setReloadAdminAssignments,
  toggleQuestionOverview,
} from '../../actions';
import {
  getAllRatesAdmins,
  loadAssignments,
  onDeleteAssignment,
  onEditAssignment,
  submitQuestionsGPT,
  submitSummary,
} from '../../actionsSagas';
import {
  getActiveStatus,
  getAssignments,
  getAssignmentsCount,
  getAwaitingApproval,
  getIsBackFromQuestion,
  getIsReloadAdminAssignments,
  getIsViewRates,
  getLoading,
  getLoadingCreateQuestions,
  getLoadingSummary,
  getMyStudyPrograms,
  getNoGroups,
  getSelectedAdmin,
  getSelectedRate,
  getSummariesSelector,
  getSummary,
  isChangingType,
} from '../../selectors';
import Assignemnts from './Assignemnts';

const mapStateToProps = (state, ownProps) => ({
  assignments: getAssignments(state),
  selectedAdmin: getSelectedAdmin(state),
  activeStatus: getActiveStatus(state),
  selectedRate: getSelectedRate(state),
  isViewRates: getIsViewRates(state),
  user: getUser(state),
  rolesPermissions: getRolesPermissions(state),
  generalRolesPermissions: getGeneralRolesPermissions(state),
  isChangingType: isChangingType(state),
  loading: getLoading(state),
  awaitingApproval: getAwaitingApproval(state),
  isReloadAdminAssignments: getIsReloadAdminAssignments(state),
  assignmentsCount: getAssignmentsCount(state),
  noGroups: getNoGroups(state),
  myStudyPrograms: getMyStudyPrograms(state),
  isBackFromQuestion: getIsBackFromQuestion(state),
  loadingCreateGPTquestions: getLoadingCreateQuestions(state),
  summaries: getSummariesSelector(state),
  loadingSummary: getLoadingSummary(state),
  summary: getSummary(state),
});

const mapDispatchToProps = (dispatch) => ({
  onEditAssignment: (assignment, isEditStatus, rejected) => {
    dispatch(onEditAssignment(assignment, isEditStatus, rejected));
  },
  onLoadAssignments: (admin, status, studyProgram) => {
    dispatch(loadAssignments(admin, getStatusByName(status), studyProgram));
  },
  onQuestionDetails: (assignment, rate) => {
    dispatch(onShowQuestionDetails(assignment, rate));
    dispatch(toggleQuestionOverview(true));
  },
  onQuestionOverview: (assignment) => {
    dispatch(onShowQuestionOverview(assignment));
    dispatch(toggleQuestionOverview(true));
  },
  onDelete: (assignment) => {
    dispatch(onDeleteAssignment(assignment));
  },
  updateLoading: (loading) => {
    dispatch(setLoading(loading));
  },
  onLoadAdmins: (
    getInactiveAdmins,
    removingApprovalFilter = false,
    isSetAdmin,
  ) => {
    dispatch(
      getAllRatesAdmins(getInactiveAdmins, removingApprovalFilter, isSetAdmin),
    );
  },
  setReloadAdminAssignments: (reload) => {
    dispatch(setReloadAdminAssignments(reload));
  },
  toggleQuestionOverview: (value) => {
    dispatch(toggleQuestionOverview(value));
  },
  setLoadingCreateGPTquestion: (value) => {
    dispatch(setLoadingCreateGPTquestion(value));
  },
  showWarning: (title, message) =>
    dispatch(Notifications.warning({ title, message }, 'failure')),
});

const AssignemntsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Assignemnts);

export default addAbilityToOpenModal(AssignemntsContainer);
